export default __webpack_public_path__ + "static/media/Pending.bec4997f.svg";